import { Link } from "react-router-dom";
import { PageHero } from "@/components/PageHero";
import { MaskLines, Reveal } from "@/components/Motion";

const STORY = [
  "Lise’s Sugar Studio began with a simple love for creating something sweet and making people feel special.",
  "What started in my home kitchen as a creative outlet slowly became something much bigger. I fell in love with the process of turning simple ingredients into desserts that could become part of someone’s birthday, celebration, gathering, or just an ordinary day that deserved a little sweetness.",
  "Over time, the vision grew. What began with cheesecakes evolved into a dessert studio centered around thoughtfully made cookies, cupcakes, and cheesecake slices.",
  "Lise’s Sugar Studio is about more than dessert. It’s about the little moments surrounding it — the excitement when a box is opened, the first bite, the dessert everyone talks about after the celebration is over.",
  "Based in Clifton Heights, Pennsylvania, Lise’s Sugar Studio is a small-batch dessert studio creating beautiful, indulgent treats with intention, creativity, and a whole lot of love.",
];

const VALUES = [
  { t: "Baked to order", d: "Nothing waits on a shelf. Every order is made fresh for its pickup." },
  { t: "Finished by hand", d: "Piping, stacking and packaging are done with the same care as the baking." },
  { t: "Made to be given", d: "Desserts presented beautifully enough to be the gift itself." },
];

export default function About() {
  return (
    <main data-testid="about-page">
      <PageHero eyebrow="About" lines={["A studio built", <span className="italic text-mocha">on sweetness.</span>]}
        intro="Lise’s Sugar Studio is a boutique dessert studio in Clifton Heights, Pennsylvania." />
      <section className="mx-auto max-w-[1440px] px-5 md:px-10 pb-24 grid lg:grid-cols-12 gap-14 items-start">
        <Reveal className="lg:col-span-6 lg:sticky lg:top-28 relative h-[480px] md:h-[680px] overflow-hidden">
          <img src="/img/flavor-red-brookie.jpg" alt="Red Brookie cookie" className="absolute inset-0 w-full h-full object-cover bg-[#F1EDE4]" />
        </Reveal>
        <div className="lg:col-span-5 lg:col-start-8 lg:pt-16">
          <MaskLines lines={["Thoughtful,", <span className="italic text-mocha">from first bite</span>, "to last crumb."]} className="font-display font-light text-5xl md:text-6xl leading-[0.95]" />
          <Reveal delay={0.1} className="mt-10 space-y-5 text-mocha leading-relaxed text-base md:text-lg">
            <p data-testid="about-story-lead" className="font-display text-2xl md:text-3xl text-cocoa leading-snug">{STORY[0]}</p>
            {STORY.slice(1).map((s) => <p key={s.slice(0, 20)}>{s}</p>)}
            <p className="font-display italic text-2xl text-cocoa pt-4">Thank you for allowing me to be a small part of your sweetest moments.</p>
          </Reveal>
          <Reveal delay={0.2}><p className="font-display italic text-4xl text-cocoa mt-10">— Lise</p></Reveal>
        </div>
      </section>
      <section className="bg-espresso text-cream">
        <div className="mx-auto max-w-[1440px] px-5 md:px-10 py-24 md:py-32 grid md:grid-cols-3 gap-12">
          {VALUES.map((v, i) => (
            <Reveal key={v.t} delay={i * 0.1} className="border-t border-cream/20 pt-6">
              <p className="font-display italic text-gold text-2xl">0{i + 1}</p>
              <p className="font-display text-4xl mt-3">{v.t}</p>
              <p className="text-[#D9CBBC] mt-4 leading-relaxed">{v.d}</p>
            </Reveal>
          ))}
        </div>
      </section>
      <section className="mx-auto max-w-[1440px] px-5 md:px-10 py-24 flex flex-col md:flex-row md:items-center justify-between gap-8">
        <p className="font-display text-4xl md:text-5xl font-light">Ready when you are.</p>
        <div className="flex flex-wrap gap-3">
          <Link to="/shop" data-testid="about-shop-cta" className="btn btn-dark">Shop Desserts</Link>
          <Link to="/custom-orders" data-testid="about-custom-cta" className="btn btn-line">Custom Orders</Link>
        </div>
      </section>
    </main>
  );
}
